import {forwardRef} from 'react';

import styles from '@/components/soopi/styles.module.css';
import globalDomains from '@/utils/global-domains';

const SoopiLandingModal = forwardRef(({handleClose}, ref) => {
  return (
    <div className={styles['modal-container']}>
      <iframe
        src={globalDomains.SOOPI_AFREECATV}
        className={styles.soopiLandingContainer}
      />
      <button className={styles.closeIconButton} onClick={handleClose} />

      <button className={styles.closeTextButton} onClick={handleClose} />
    </div>
  );
});

SoopiLandingModal.displayName = 'SoopiLandingModal';

export default SoopiLandingModal;
